exports.isAuthenticated = function () {
    return !!window.User.authenticated;
};
